import React from 'react';
import styles from './InlineCode.css.js';

const InlineCode = ({
  children
}) => /*#__PURE__*/React.createElement("code", {
  className: styles.Code
}, children);

export { InlineCode };
